import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

export const useRedesignLayoutStyles = makeStyles({
  contentBackground: {
    backgroundColor: redesignTheme.colors.background,
  },
});
